import { Injectable } from '@angular/core';
import math from 'mathjs';

@Injectable()
export class StandardFormulas {
  calculateStressFactor = (toolDiameter: number, stickOut: number, axDepth: number): number => {
    return (2 * stickOut * axDepth - math.pow(axDepth, 2)) / (8 * math.pow(toolDiameter, 2));
  };

  calculateMomentOfInertia = (toolDiameter: number): number => {
    return (math.PI * math.pow(toolDiameter, 4.0)) / 64.0;
  };

  calculateBendingMoment = (stickOut: number, axDepth: number, force: number): number => {
    return force * (stickOut - axDepth / 2);
  };

  calculateTensileStress = (toolDia: number, stickOut: number, axDepth: number, force: number): number => {
    return (
      (this.calculateBendingMoment(stickOut, axDepth, force) * toolDia) / (2 * this.calculateMomentOfInertia(toolDia))
    );
  };

  calculateRigidFactor = (toolDia: number, stickOut: number, axDepth: number): number => {
    return (
      (116 * math.pow(toolDia, 3)) /
      (math.pow(axDepth, 3) - 6 * math.pow(stickOut, 2) * axDepth + 8 * math.pow(stickOut, 3))
    );
  };

  calculateDeflectFactor = (toolDia: number, stickOut: number, axDepth: number): number => {
    return axDepth / (2 * toolDia * this.calculateRigidFactor(toolDia, stickOut, axDepth));
  };
}
